export default __webpack_public_path__ + "static/media/edit-green.cb26d8b3.svg";